window.URL_API = 'https://borapi.sprinta.com.br/'
// window.URL_API = 'https://appi.sprinta.com.br/'
window.adyen_public_api = "10001|B2D02C75AD12FC538242B447AF0AAC33A470DCB2B278FDB7F8B1D252BEBC1F86F3EE506A6AC6F396CA060ED99210ECA11C7472053B5ED4ADCF058D314569E162F2D1073670FEBFF1209F8479D5C08BC8C0F7E507C27FD6F0DB299B60A79AB7ADCA8E55A1F610439295D541CCAE993726F42B8DACE200D8DE3E1759CF57A897F9415D8696318A900A0A716E5006210BF61C73603E9359E74D06B68FE50641944F385E8D17748C901925D06FE779ADC79940BE2160E6F1E5842B173BE73CFCFFFFA930E15FA66B68E9BFF70156D2D0DD6184B6A1A34358B399865B07219725466477133795342881745F27B3057311037F67706C4C43BD0EF1FA9C26496BE40803"
window.checkout_api = "https://borapi.sprinta.com.br/api2/"
// window.checkout_api = "https://sprinta.com.br/api2/"
window.payment_api = `https://borapi.sprinta.com.br/payment_service/`
// window.payment_api_boleto = `https://payment-service.k8s.sprinta.com.br/`
window.payment_api_boleto = `https://borapi.sprinta.com.br/payment_service/`
// window.payment_api_pix = `https://appi.sprinta.com.br/payment_service/`
window.payment_api_pix = `https://borapi.sprinta.com.br/payment_service/`
// window.payment_api_pix = `https://payment-service.k8s.sprinta.com.br/`
// window.payment_api_card = `https://payment-service.k8s.sprinta.com.br/`
window.payment_api_card = `https://borapi.sprinta.com.br/payment_service/`


window.link_boleto = `${window.payment_api_boleto}boleto/`
window.link_across = `${window.payment_api}pay_across/`
window.URL_ASSETS_BASE = 'https://www.sprinta.com.br/'
window.URL_BASE_OLD = 'https://www.sprinta.com.br/'
window.NOTFOUND = "https://app.sprinta.com.br/404"


// WEBPACK FOOTER //
// ./src/_config.js